module.exports = __webpack_public_path__ + "img/logo-readcoop2.3f746ef7.svg";